/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {
  contactPlatformCompany,
  errorSegment, gdprTermsAndConditionsSegment, infoSegment, invalidateLeSegment,
  markPlatformInvoiceAsPaidSegment,
  platformAdminLeSubscriptionSegment,
  platformAdminSegment,
  platformInvoicesSegment, reactivateLeSegment
} from './shell-navigation-constants';

export const platformAdminLeSubscriptionUrl = (legalEntityUuid: any) => [
  '/',
  'admin',
  platformAdminSegment,
  platformAdminLeSubscriptionSegment,
  legalEntityUuid
];

export const markPlatformInvoiceAsPaidUrl = (platformInvoiceUuid: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        'admin',
        's',
        platformAdminSegment,
        platformInvoicesSegment,
        markPlatformInvoiceAsPaidSegment,
        platformInvoiceUuid
      ],
    },
  }
];

export const invalidateLeUrl = (subscriptionUuid: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        'admin',
        's',
        platformAdminSegment,
        platformAdminLeSubscriptionSegment,
        invalidateLeSegment,
        subscriptionUuid
      ],
    },
  }
];

export const reactivateLeUrl = (subscriptionUuid: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        'admin',
        's',
        platformAdminSegment,
        platformAdminLeSubscriptionSegment,
        reactivateLeSegment,
        subscriptionUuid
      ],
    },
  }
];

export const platformCompanyContactFormUrl = () => ['/', { outlets: { popup: ['popup', contactPlatformCompany] } }];
export const errorUrl = ['/', errorSegment];

export const loggedInTermsAndConditionsPageUrl = [gdprTermsAndConditionsSegment];
export const guestTermsAndConditionsPageUrl = [infoSegment, gdprTermsAndConditionsSegment];
